import TintBadge from '@shared/components/TintBadge';
import { STAGE_STATUS_METADATA } from '../constants';
import type { EStageStatus } from '../types';

const StageStatusBadge = ({ status }: { status: EStageStatus }) => (
  <TintBadge color={STAGE_STATUS_METADATA[status].color}>{STAGE_STATUS_METADATA[status].label}</TintBadge>
);

export default StageStatusBadge;
